import * as React from 'react';

import { SVGProps } from '../../types';

export const IconThumbsDownSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    focusable="false"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M7 5H14C14.5523 5 15 5.44772 15 6L15 13.611C15 13.8612 14.9062 14.1023 14.7372 14.2867L9.58143 19.9112C9.53912 19.9573 9.46528 19.9537 9.42772 19.9036L8.74165 18.9889C8.28712 18.3828 8.21401 17.572 8.5528 16.8944L9.77641 14.4472C10.1089 13.7823 9.62536 13 8.88198 13L5.5 13C3.6459 13 2.58754 10.8833 3.7 9.4C3.89474 9.14036 4 8.82456 4 8.5L4 8C4 6.34315 5.34315 5 7 5Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M21 13C21 13.5523 20.5523 14 20 14L18 14L18 5L20 5C20.5523 5 21 5.44772 21 6L21 13Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);
